import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Card, Alert } from "antd";
import StepsHeader from "./StepsHeader";
import Identification from "./Identification";
import Options from "./Options";
import Payment from "./Payment";
import LegalAndSupport from "./LegalAndSupport";
import Producer from "Components/Shared/Producer";
import FreeCourseTeaser from "./FreeCourseTeaser";
import useMediaQuery from "use-media-antd-query";
import {
  checkoutFormControlsOverrideCss,
  checkoutPrimaryCheckboxOverrideCss,
  checkoutTypographyExpandLinkCss,
  checkoutLinkButtonOverrideCss,
  checkoutSearchButtonOverrideCss,
  checkoutCountryTriggerOverrideCss,
  checkoutPrimaryButtonOverrideCss,
  checkoutModalControlsOverrideCss,
} from "utils/checkoutTheme";

const MAIN_CARD_SCOPE = ".main-container-card";
/** Cupão (SideBar) vive fora do card principal; mesmo tema de bordas dos inputs. */
const COUPON_SIDEBAR_SCOPE = ".coupon-code";
/** Preço / descrição do produto (link "Ver mais" em Typography). */
const PRICING_CARD_SCOPE = ".pricing-card";

const MainContent = ({ productData, step, data, duplicatesSales, actionHandler, customStyle, identificationKey }) => {
  const { t } = useTranslation();
  const colSize = useMediaQuery();
  const isWidget = window?.location?.hash?.substr(1) === "widget";
  const mobileSizes = ["xs", "sm", "md"];
  const isMobileSize = mobileSizes.includes(colSize);

  useEffect(() => {}, []);

  const checkboxThemeCss = checkoutPrimaryCheckboxOverrideCss(MAIN_CARD_SCOPE, customStyle);
  const formControlsCss = [
    checkoutFormControlsOverrideCss(MAIN_CARD_SCOPE, customStyle),
    checkoutFormControlsOverrideCss(COUPON_SIDEBAR_SCOPE, customStyle),
    checkoutFormControlsOverrideCss(PRICING_CARD_SCOPE, customStyle),
  ]
    .filter(Boolean)
    .join("\n");

  const typographyExpandCss = [
    checkoutTypographyExpandLinkCss(MAIN_CARD_SCOPE, customStyle),
    checkoutTypographyExpandLinkCss(PRICING_CARD_SCOPE, customStyle),
    checkoutTypographyExpandLinkCss(COUPON_SIDEBAR_SCOPE, customStyle),
  ]
    .filter(Boolean)
    .join("\n");

  const miscControlsCss = [
    checkoutLinkButtonOverrideCss(MAIN_CARD_SCOPE, customStyle),
    checkoutSearchButtonOverrideCss(MAIN_CARD_SCOPE, customStyle),
    checkoutCountryTriggerOverrideCss(MAIN_CARD_SCOPE, customStyle),
  ]
    .filter(Boolean)
    .join("\n");

  // Global accent for the main Spinner (var inherited by every <Spinner>, no per-instance edits)
  const spinAccent = customStyle?.primary?.backgroundColor;
  const spinColorCss = spinAccent ? `:root { --sp-spin-color: ${spinAccent}; }` : "";

  // Modal.confirm dialogs (VAT no-vatid, etc.) portal as `.ant-modal-confirm`,
  // outside any scoped theme - theme their OK/Cancel buttons + checkbox here.
  const confirmThemeCss = [
    checkoutPrimaryButtonOverrideCss(".ant-modal-confirm", customStyle),
    checkoutModalControlsOverrideCss(".ant-modal-confirm", customStyle),
    checkoutPrimaryCheckboxOverrideCss(".ant-modal-confirm", customStyle),
  ]
    .filter(Boolean)
    .join("\n");

  const themeInjectedCss = [spinColorCss, confirmThemeCss, checkboxThemeCss, formControlsCss, typographyExpandCss, miscControlsCss]
    .filter(Boolean)
    .join("\n");

  return (
    <div>
      {themeInjectedCss ? <style>{themeInjectedCss}</style> : null}
      <StepsHeader step={step} data={data} actionHandler={actionHandler} customStyle={customStyle} />{" "}
      <Card className="main-container-card no-radius-bottom">
        {step === 0 && <Identification key={identificationKey} data={data} actionHandler={actionHandler} customStyle={customStyle} />}
        {step === 1 && duplicatesSales > 0 && (
          <Alert
            className="alert-duplicates-sales"
            style={{ marginBottom: "20px" }}
            message={t("mainContent.duplicateWarningTitle", { name: data?.identification?.name.toUpperCase() || "" })}
            description={<Trans i18nKey="mainContent.duplicateWarningDescription" components={{ strong: <strong /> }} />}
            type="warning"
            showIcon
          />
        )}

        {step === 1 && <Options customStyle={customStyle} step={step} productData={productData} data={data} actionHandler={actionHandler} />}
        {step === 2 && <Payment productData={productData} data={data} actionHandler={actionHandler} customStyle={customStyle} />}

        {/* Free Course / Teaser */}
        {step === 99 && <FreeCourseTeaser productData={productData} data={data} actionHandler={actionHandler} customStyle={customStyle} />}

        {!isWidget && isMobileSize && <Producer data={data} isMobile={isMobileSize} isWidget={isWidget} customStyle={customStyle} />}
      </Card>
      <LegalAndSupport data={data} productData={productData} isMobile={isMobileSize} customStyle={customStyle} />
    </div>
  );
};

export default MainContent;
